import { createServer, Model, Response } from 'miragejs';
import assetAllocation from '../mock/data/assetAllocation.json';
import currency from '../mock/data/currency.json';
import people from '../mock/data/people.json';
import portfolios from '../mock/data/portfolios.json';
import chartData from '../mock/data/chartData.json';
import chartTotals from '../mock/data/chartTotals.json';
import countryOptions from '../mock/data/countryOptions.json';
import groupOptions from '../mock/data/groupOptions.json';
import plans from '../mock/data/plans.json';
import holdings from '../mock/data/holdings.json';
import fundPerformanceGraph from '../mock/data/fundperformancegraph.json';
import fundToolTip from '../mock/data/fundtooltip.json';
import fundAllocation from '../mock/data/fundAllocation.json';
import valuationSummaryChart from '../mock/data/valuationSummaryChart.json';
import transactions from '../mock/data/transactions.json';
import datafeeds from '../mock/data/datafeeds.json';
import documentexport from '../mock/data/documentexport.json';
import buylist from '../mock/data/buylist.json';
import research from '../mock/data/Research.json';
// import messages from "../mock/data/loadMessages.json"
import sentMessages from '../mock/data/sentMessages.json';
import preferences from '../mock/data/preferences.json';
// import imsApprovals from "../mock/data/imsApprovals.json"
import imsApprovals from '../mock/data/imsApprovalsCash.json';
import openBanking from '../mock/data/openbanking.json';
import news from '../mock/data/news.json';
import pdfPayload from '../mock/data/examplePDFValuationExportPayload.json';
import excelPayload from '../mock/data/exampleExcelValuationExportPayload.json';
import permissions from '../mock/data/permissions.json';
import selfManagedAssets from '../mock/data/selfManagedAssets.json';
import selfManagedProductTypes from '../mock/data/selfManagedProductTypes.json';
import fundlinks from '../mock/data/clarityfundlinks.json';
import wealthplans from '../mock/data/wealthplans.json';
import wealthplanNotes from '../mock/data/wealthplanNotes.json';
import clientSearch from '../mock/data/clientSearch.json';

import { makeRecipients } from '../factories/recipient';

import { RestSerializer } from 'miragejs';
import { makeMessages } from '../factories/secureMessage';
import { sample } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { faker } from '@faker-js/faker';

// When VUE_APP_MOCK_SEED is set, all rng() calls in this file use a
// seeded PRNG (mulberry32) so every run produces identical mock values.
function _mulberry32(seed) {
    return function () {
        seed |= 0;
        seed = (seed + 0x6d2b79f5) | 0;
        var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
const _mockSeed = process.env.VUE_APP_MOCK_SEED != null ? parseInt(process.env.VUE_APP_MOCK_SEED, 10) : NaN;
const rng = !isNaN(_mockSeed) ? _mulberry32(_mockSeed) : Math.random.bind(Math);
if (!isNaN(_mockSeed)) faker.seed(_mockSeed);

const recipients = makeRecipients(10);

let proxyName = '/clarity';
if (process.env.VUE_APP_TARGET_OVERRIDE === 'true') {
    proxyName = '/clarityadmin';
}

export const makeServer = (config) => {
    config = { ...{ environment: 'development', passthrough: [] }, ...config };
    console.log('config', config);
    let server = createServer({
        environment: config.environment,
        serializers: {
            application: RestSerializer,
            // application: RestSerializer.extend({
            //   root: false,
            //   embed: true
            // })
        },

        models: {
            assetAllocation: Model,
            portfolio: Model,
            people: Model,
            currency: Model,
            plan: Model,
            holdings: Model,
            valuationSummaryChart: Model,
            datafeed: Model,
            message: Model,
            sentMessage: Model,
            recipient: Model,
            openBanking: Model,
            news: Model,
        },
        fixtures: {
            assetAllocation: assetAllocation,
            portfolios: portfolios,
            people: people,
            chartData: chartData,
            chartTotals: chartTotals,
            countryOptions,
            groupOptions,
            currency: currency,
            plans: plans,
            holdings: holdings,
            fundPerformanceGraph: fundPerformanceGraph,
            fundToolTip: fundToolTip,
            fundAllocation: fundAllocation,
            valuationSummaryChart: valuationSummaryChart,
            transactions: transactions,
            datafeeds: datafeeds,
            documentexport: documentexport,
            buylist,
            research: research,
            sentMessages,
            recipients: recipients,
            senders: recipients,
            messages: makeMessages(300, recipients, { archived: 0 }),
            preferences,
            imsApprovals,
            openBanking,
            news,
            pdfPayload: pdfPayload,
            excelPayload: excelPayload,
            permissions,
            selfManagedAssets,
            selfManagedProductTypes,
            fundlinks,
            wealthplans,
            wealthplanNotes,
            clientSearch,
        },

        seeds(server) {
            server.loadFixtures('assetAllocation');
            server.loadFixtures('buylist');
            server.loadFixtures('chartData');
            server.loadFixtures('chartTotals');
            server.loadFixtures('countryOptions');
            server.loadFixtures('currency');
            server.loadFixtures('datafeeds');
            server.loadFixtures('documentexport');
            server.loadFixtures('fundAllocation');
            server.loadFixtures('fundPerformanceGraph');
            server.loadFixtures('fundToolTip');
            server.loadFixtures('groupOptions');
            server.loadFixtures('holdings');
            server.loadFixtures('messages');
            server.loadFixtures('people');
            server.loadFixtures('plans');
            server.loadFixtures('portfolios');
            server.loadFixtures('preferences');
            server.loadFixtures('recipients');
            server.loadFixtures('senders');
            server.loadFixtures('research');
            server.loadFixtures('sentMessages');
            server.loadFixtures('transactions');
            server.loadFixtures('valuationSummaryChart');
            server.loadFixtures('imsApprovals');
            server.loadFixtures('openBanking');
            server.loadFixtures('news');
            server.loadFixtures('pdfPayload');
            server.loadFixtures('excelPayload');
            server.loadFixtures('permissions');
            server.loadFixtures('selfManagedAssets');
            server.loadFixtures('selfManagedProductTypes');
            server.loadFixtures('fundlinks');
            server.loadFixtures('wealthplans');
            server.loadFixtures('wealthplanNotes');
            server.loadFixtures('clientSearch');
        },

        routes() {
            this.urlPrefix = process.env.VUE_APP_APIENDPOINT;

            //  Use 'normal' (standard) rest type routes here
            this.get('/performance/fund/:isin', (schema) => {
                return new Response(200, {}, schema.db.fundPerformanceGraph[0]);
            });
            this.get('/morningstar/fundinfotooltipdata', (schema, request) => {
                const isin = request.queryParams.isin;
                console.log('tooltip - isin', isin);
                return new Response(200, {}, schema.db.fundToolTip[0]);
            });
            this.get('/securemessaging/load-message/:messageID', (schema, request) => {
                const id = request.params.messageID;
                let msg = schema.messages.findBy({ message_id: id });
                if (!msg) {
                    // not an inbox item -> therefore try sent items
                    msg = schema.sentMessages.findBy({ message_id: id });
                }

                return new Response(200, {}, msg.attrs);
            });

            // Secure Messaging Route
            this.get('/securemessaging/load-messages', (schema, request) => {
                const params = request.queryParams;

                let page = params && params.page ? parseInt(params.page) : 1;
                let per_page = params && params.per_page ? parseInt(params.per_page) : 20;
                let limit = per_page ?? 20;
                let start = page * per_page;
                let end = start + limit;

                let messages = schema.db.messages;
                let filtered = messages.slice(start, end);

                return new Response(
                    200,
                    {},
                    {
                        messages: filtered,
                        meta: {
                            page: 3,
                            totalCount: messages.length,
                            per_page: per_page,
                        },
                    }
                );
            });

            this.get('/securemessaging/load-new-messages', (schema) => {
                let messages = schema.db.messages;
                let filtered = messages.slice(0, 1);

                return new Response(
                    200,
                    {},
                    {
                        messages: filtered,
                    }
                );
            });

            this.post('/securemessaging/load-messages', (schema, request) => {
                const params = JSON.parse(request.requestBody);

                let page = params && params.page ? parseInt(params.page) : 1;
                let per_page = params && params.perPage ? parseInt(params.perPage) : 20;
                let limit = per_page ?? 20;
                let start = page * per_page;
                let end = start + limit;

                let messages = schema.db.messages;
                let filtered = messages.slice(start, end);

                return new Response(
                    200,
                    {},
                    {
                        messages: filtered,
                        meta: {
                            page: page,
                            totalCount: messages.length,
                            per_page: per_page,
                        },
                    }
                );
            });

            this.get('/securemessaging/loadSentMessages', (schema) => {
                return new Response(200, {}, schema.db.sentMessages);
            });
            this.post('/securemessaging/update-message', (schema, request) => {
                const params = JSON.parse(request.requestBody);
                const id = params.messageID;
                let msg = schema.messages.where({ message_id: id });
                delete params.messageID;

                msg.update(params);

                return new Response(200, {}, { success: true });
            });
            this.post('/securemessaging/add-message', (schema, request) => {
                const id = uuidv4();
                const params = JSON.parse(request.requestBody);
                console.log('id', id);
                console.log('params', params);
                schema.messages.create(params);
                return new Response(200, {}, { success: true, messageid: id });
            });
            // Secure Messaging Attachments
            // get signedURL response
            this.post('/securemessaging/upload-attachment', (schema, request) => {
                const attachmentID = uuidv4();
                const params = request.requestBody;
                console.log('params in upload', params);

                return new Response(
                    200,
                    {},
                    {
                        signedURL: 'this_is_a_nonsense_signed_url_for_mocking_only',
                        messageID: params.messageID,
                        attachmentID: attachmentID,
                        Expires: 3600,
                    }
                );
            });
            // upload to AWS S3
            this.put('this_is_a_nonsense_signed_url_for_mocking_only', () => {
                return new Response(200, {}, {});
            });

            //open banking routes.
            this.get('/openbanking/accounts', (schema) => {
                return new Response(200, {}, schema.db.openBanking[0]['data']);
            });

            this.get('/openbanking/providers', (schema) => {
                return new Response(200, {}, schema.db.openBanking[0]['providers']);
            });

            this.get('/openbanking/create', (schema) => {
                return new Response(200, {}, schema.db.openBanking[0]['create']);
            });

            this.get('/openbanking/revoke', (schema) => {
                return new Response(200, {}, schema.db.openBanking[0]['create']);
            });

            console.log('got down to before the drupalroute');

            if (process.env.VUE_APP_D9ENDPOINT_NEW_PROXY !== 'true') {
                // As url strings are now /clarity?=path/to/route - this is actually a query string.
                // As such, we need to break down the querysting to direct to the appropriate logic
                useDrupalRoute(this, config.passthrough);
            } else {
                // no longer using the /clarity etc etc so we will mock all routes as per the above.
                this.get('/valuation/plan/holdings/:plan/:date', (schema) => {
                    return useHoldings(schema);
                });
                this.get('/valuation/plan/summary/:plan/:date', () => {
                    return new Response(200, {}, { total: rng() * (5000000 - 10000) + 10000 });
                });
                this.get('/valuation/plan/summary/:plan', () => {
                    return new Response(200, {}, { total: rng() * (5000000 - 10000) + 10000 });
                });
                this.get('/valuation/plans', (schema) => {
                    return new Response(200, {}, schema.db.plans);
                });
                this.get('/valuation/portfolios', (schema) => {
                    return useValuationPortfolioRoute(schema);
                });
                this.get('/valuation/v2/datafeeds', (schema) => {
                    return new Response(200, {}, schema.db.datafeeds[0].client);
                });
                this.get('/valuation/v2/datafeeds/platforms', (schema) => {
                    return new Response(200, {}, schema.db.datafeeds[0].v2platforms);
                });
                this.get('/valuation/datafeedplatforms', (schema) => {
                    return new Response(200, {}, schema.db.datafeeds[0].platforms);
                });
                this.get('/valuation/summary/chart/:portfolio/:people/:timeframe', (schema, request) => {
                    const path = request.queryParams.path;
                    return useValuationSummaryChart(path, schema);
                });
                this.get('/valuation/summary/chart/:portfolio/:people/:timeframe/:date', (schema, request) => {
                    const path = request.queryParams.path;
                    return useValuationSummaryChart(path, schema);
                });
                this.get('/valuation/summary/policychart/', (schema, request) => {
                    const path = request.queryParams.path;
                    return useValuationPolicySummaryChart(path, schema);
                });
                this.get('/valuation/summary/charttotals/:portfolio/:people/:date', (schema, request) => {
                    const path = request.queryParams.path;
                    return useValuationSummaryChartTotals(path, schema);
                });
                this.get('/valuation/summary/total/:portfolio/:people/:date', () => {
                    return new Response(200, {}, { total: rng() * (2000000 - 1000000) + 1000000 });
                });
                this.get('/valuation/summary/total/:portfolio', () => {
                    return new Response(200, {}, { total: rng() * (2000000 - 1000000) + 1000000 });
                });
                this.get('/permissions/client/people', (schema) => {
                    return new Response(200, {}, schema.db.people);
                });
                this.get('/permissions/client/investmentpermissionsgranted', (schema) => {
                    return new Response(200, {}, schema.db.permissions[0]['granted']);
                });
                this.get('/permissions/client/investmentpermissionsreceived', (schema) => {
                    return new Response(200, {}, schema.db.permissions[0]['received']);
                });
                this.get('/rest/api/get/currencies', (schema) => {
                    return new Response(200, {}, schema.db.currency[0]);
                });
                this.get('/assetallocation/full/:portfolio/:people/:date', (schema) => {
                    return new Response(200, {}, schema.db.assetAllocation[0]);
                });
                this.get('/assetallocation/fund/:isin/:date', (schema) => {
                    return new Response(200, {}, schema.db.fundAllocation[0]);
                });
                this.get('/valuation/summary/plantotals/:plans/:date', (schema) => {
                    return new Response(200, {}, schema.db.valuationSummaryChart);
                });
                this.get('/transaction/plan/alltransactions/:plan/:date', (schema) => {
                    return new Response(200, {}, { transactions: schema.db.transactions });
                });
                this.get('/buylist/full/pwc', (schema) => {
                    return new Response(200, {}, { data: schema.db.buylist[0] });
                });
                this.get('/buylist/full', (schema) => {
                    return new Response(200, {}, { data: schema.db.buylist[1] });
                });
                this.get('/researchlibrary', (schema) => {
                    return new Response(200, {}, schema.db.research[0]);
                });
                this.get('/clientdirectory/:path', (schema, request) => {
                    const path = request.params.path;
                    return useClientDirectoryService(path);
                });
                this.get('/clientdirectory/:path/:second', (schema, request) => {
                    const path = request.params.path;
                    return useClientDirectoryService(path);
                });
                this.get('/securemessaging/recipients', (schema) => {
                    return new Response(200, {}, schema.db.recipients);
                });
                this.get('/securemessaging/sendersList', (schema) => {
                    return new Response(200, {}, schema.db.senders);
                });
                this.get('/securemessaging/recipientsList', () => {
                    return new Response(200, {}, makeRecipients(10));
                });
                this.get('/wealthplan/plans', (schema) => {
                    return new Response(200, {}, schema.db.wealthplans[0]);
                });
                this.get('/wealthplan/plans/notes/:plan', (schema) => {
                    return new Response(200, {}, { notes: schema.db.wealthplanNotes[0].list });
                });
                this.get('/ims/approvalrecords', (schema) => {
                    return new Response(200, {}, schema.db.imsApprovals[0]);
                });
                this.get('/ims/sendmethod', () => {
                    return new Response(200, {}, { method: 'securemessaging' });
                });
                this.get('/selfmanaged/assets', () => {
                    return useSelfManagedHoldings('/assets');
                });
                this.get('/selfmanaged/liabilities', () => {
                    return useSelfManagedHoldings('/assets');
                });
                this.get('/selfmanaged/producttypes', () => {
                    return useSelfManagedHoldings('/producttypes');
                });
                this.get('/selfmanaged/clarityfundlinks', () => {
                    return useSelfManagedHoldings('/clarityfundlinks');
                });
                this.get('/selfmanaged/liabilitytypes', () => {
                    return useSelfManagedHoldings('/producttypes');
                });
                this.get('/newsletter', () => {
                    return new Response(200, {}, { status: sample([true, false]) });
                });
                this.get('/rest/api/get/clientsearch', (schema) => {
                    return new Response(200, {}, schema.db.clientSearch[0]);
                });
                this.get('/isa_allowance/list', (schema) => {
                    const data = {};
                    schema.db.people.forEach((person) => {
                        data[person.uuid] = [{ allowanceUsed: Math.floor(rng() * 20001) }];
                    });
                    return new Response(200, {}, data);
                });
                this.get('/news/read', () => {
                    return new Response(200, {}, []);
                });
                // Empty body = no urgent alert, so the popup never covers the page under test
                this.get('/core/urgent-message', () => {
                    return new Response(200, {}, '');
                });
                this.get('/news', (schema) => {
                    return new Response(200, {}, schema.db.news);
                });

                // POST RECORDS
                this.post('/valuation/portfolios/benchmark/:portfolio', () => {
                    return new Response(200, {}, { success: true, benchmarkID: Math.floor(rng() * 1000) });
                });
                this.post('/valuation/portfolios', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data.name && data.plans) {
                        return new Response(
                            200,
                            {},
                            { portfolioID: Math.floor(1000000000 + rng() * 9000000).toString() }
                        );
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Please ensure that the following data has been submitted: Name, Plans',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.post('/valuation/v2/datafeeds', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data.feed_id && data.provider_reference) {
                        return new Response(200, {}, { success: true });
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message:
                                    'Please ensure that the following data has been submitted: feed_id, provider_reference',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.post('/document_export', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data.payload) {
                        if (data.request_type === 'PDF') {
                            return new Response(200, {}, schema.db.pdfPayload[0]);
                        } else if (data.request_type === 'Excel') {
                            return new Response(200, {}, schema.db.excelPayload[0]);
                        } else {
                            return new Response(
                                400,
                                {},
                                {
                                    message: 'Did not recognise request_type',
                                    success: false,
                                    error: true,
                                }
                            );
                        }
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Please ensure that the following data has been submitted: payload',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.post('/permissions/client/investmentpermissionsgranted', () => {
                    // mirage is not happy with crypto so change success for string id instead
                    // return new Response(200, {}, {success: crypto.randomUUID()});
                    return new Response(200, {}, { success: Math.floor(1000 + rng() * 900) });
                });
                this.post('/selfmanaged/assets', () => {
                    return new Response(200, {}, { success: true, assetId: '13355fd5-f8e6-499d-83e1-0229110ce173' });
                });
                this.post('/idp/aegon/sso', () => {
                    const responseCode =
                        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"' +
                        '        "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">' +
                        '<head>' +
                        '    <meta http-equiv="content-type" content="text/html; charset=utf-8" />' +
                        '    <title>POST data</title>' +
                        '    <link type="text/css" rel="stylesheet" href="/idp/aegon/resources/post.css" />' +
                        '</head>' +
                        '<body>' +
                        '' +
                        '    <noscript>' +
                        '        <p><strong>Note:</strong> ' +
                        '        Since your browser does not support JavaScript, ' +
                        '        you must press the button below once to proceed.</p> ' +
                        '    </noscript> ' +
                        '' +
                        '    <form method="post" ' +
                        '        action="https://claritybuy.aegon.co.uk/rest/external/authentication/sso">' +
                        '    <!-- Need to add this element and call click method, because calling ' +
                        '    submit() on the form causes failed submission if the form has another ' +
                        '    element with name or id of submit.' +
                        '    See: https://developer.mozilla.org/en/DOM/form.submit#Specification -->' +
                        '    <input type="submit" id="postLoginSubmitButton"/>' +
                        '<input type="hidden" name="SAMLResponse" value="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" /><input type="hidden" name="RelayState" value="exturl=claritycpmicrosite&relaytoken=123456&context=Top" />        <noscript>' +
                        '            <button type="submit" class="btn">Submit</button>' +
                        '        </noscript>' +
                        '    </form>' +
                        '' +
                        '</body>' +
                        '</html>';

                    return new Response(200, {}, responseCode);
                });
                this.post('/news/read', () => {
                    return new Response(200, {}, { success: true });
                });
                this.post('/newsletter', () => {
                    return new Response(200, {}, { status: true });
                });

                // PATCH RECORDS
                this.patch('/valuation/portfolios/benchmark/:benchmark', () => {
                    return new Response(200, {}, { success: true });
                });
                this.patch('/valuation/portfolios/:portfolio', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data.name && data.plans) {
                        return new Response(200, {}, { success: true });
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Please ensure that the following data has been submitted: Name, Plans',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.patch('/valuation/v2/datafeeds/:feed', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data.provider_reference) {
                        return new Response(200, {}, { success: true });
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Please ensure that the following data has been submitted: provider_reference',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.patch('/clientdirectory/clientpersonaldetails/summary', () => {
                    return new Response(200, {}, { data: preferences['personalDetails'] });
                });
                this.patch('/clientdirectory/websitesettings', () => {
                    return new Response(200, {}, { data: preferences['preferences'] });
                });
                this.patch('/ims/approvalrecords', (schema, request) => {
                    const data = JSON.parse(request.requestBody);
                    if (data['approve']) {
                        return new Response(200, {}, { success: true });
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Please ensure that the following data has been submitted: approve',
                                success: false,
                                error: true,
                            }
                        );
                    }
                });
                this.patch('/selfmanaged/assets', () => {
                    return new Response(204);
                });

                // DELETE RECORDS

                this.delete('/valuation/portfolios/:portfolio', () => {
                    return new Response(204);
                });
                this.delete('/valuation/v2/datafeeds/:feed', () => {
                    return new Response(204);
                });
                this.delete('/permissions/client/investmentpermissionsgranted/:permission', () => {
                    return new Response(204);
                });
                this.delete('/selfmanaged/assets/:asset', () => {
                    return new Response(204);
                });
            }

            console.log('after the drupal route for this one, passthrough!');

            // Passthrough always last to allow routes to resolve themselves first
            // temporarily allow auth passthrough until this is abstracted to a service.
            // Or wrapped in an auth axios wrapper
            this.passthrough();
            this.passthrough('https://cognito-identity.eu-west-1.amazonaws.com/');
            this.passthrough('https://cognito-idp.eu-west-1.amazonaws.com/');
        },
    });

    window.server = server;

    return server;
};

const useDrupalRoute = (server, passthrough) => {
    if (passthrough && passthrough.includes('/clarity')) return;

    server.get(proxyName, (schema, request) => {
        const path = request.queryParams.path;

        switch (true) {
            // Valuations
            case path.includes('/valuation/plan/holdings'):
                return useHoldings(schema);
            case path.includes('/valuation/plan/summary/'):
                return new Response(200, {}, { total: rng() * (5000000 - 10000) + 10000 });
            case path.includes('/valuation/plans'):
                return new Response(200, {}, schema.db.plans);
            case path.includes('/valuation/portfolios'):
                return useValuationPortfolioRoute(schema);
            case path.includes('/valuation/v2/datafeeds/platforms'):
                return new Response(200, {}, schema.db.datafeeds[0].v2platforms);
            case path.includes('/valuation/v2/datafeeds'):
                return new Response(200, {}, schema.db.datafeeds[0].client);
            case path.includes('/valuation/datafeedplatforms'):
                return new Response(200, {}, schema.db.datafeeds[0].platforms);
            case path.includes('/valuation/summary/chart/'):
                return useValuationSummaryChart(path, schema);
            case path.includes('/valuation/summary/policychart/'):
                return useValuationPolicySummaryChart(path, schema);
            case path.includes('/valuation/summary/charttotals/'):
                return useValuationSummaryChartTotals(path, schema);
            case path.includes('/valuation/summary/total'):
                return new Response(200, {}, { total: rng() * (2000000 - 1000000) + 1000000 });
            // Permisisons
            case path.includes('/permissions/client/people'):
                return new Response(200, {}, schema.db.people);
            case path.includes('/permissions/client/investmentpermissionsgranted'):
                return new Response(200, {}, schema.db.permissions[0]['granted']);
            case path.includes('/permissions/client/investmentpermissionsreceived'):
                return new Response(200, {}, schema.db.permissions[0]['received']);
            // Currencies
            case path.includes('/rest/api/get/currencies'):
                return new Response(200, {}, schema.db.currency[0]);
            // Asset Allocation
            case path.includes('/assetallocation/full'):
                return new Response(200, {}, schema.db.assetAllocation[0]);
            case path.includes('/assetallocation/fund/'):
                return new Response(200, {}, schema.db.fundAllocation[0]);
            case path.includes('/valuation/summary/plantotals/'):
                return new Response(200, {}, schema.db.valuationSummaryChart);
            // transactions
            case path.includes('/transaction/plan/alltransactions'):
                return new Response(200, {}, { transactions: schema.db.transactions });
            case path.includes('/buylist/full/pwc'):
                return new Response(200, {}, { data: schema.db.buylist[0] });
            case path.includes('/buylist/full'):
                return new Response(200, {}, { data: schema.db.buylist[1] });
            case path.includes('/researchlibrary'):
                return new Response(200, {}, schema.db.research[0]);
            //  preferences
            case path.includes('/clientdirectory'):
                return useClientDirectoryService(path);
            //  recipients
            case path.includes('/securemessaging/recipients'):
                return new Response(200, {}, schema.db.recipients);
            //  senderlist
            case path.includes('/securemessaging/sendersList'):
                return new Response(200, {}, schema.db.senders);
            case path.includes('/securemessaging/recipientsList'):
                return new Response(200, {}, makeRecipients(10));
            //wealthplans
            case path.includes('/wealthplan'):
                return useWealthplanRoutes(path, schema, request);
            // IMS Approvals
            case path.includes('/ims/approvalrecords'):
                return new Response(200, {}, schema.db.imsApprovals[0]);
            case path.includes('/ims/sendmethod'):
                return new Response(200, {}, { method: 'securemessaging' });
            case path.includes('/selfmanaged'):
                return useSelfManagedHoldings(path);
            case path.includes('/newsletter'):
                return new Response(200, {}, { status: sample([true, false]) });
            case path.includes('/rest/api/get/clientsearch'):
                return new Response(200, {}, schema.db.clientSearch[0]);
            case path.includes('/isa_allowance/list'): {
                const data = {};
                schema.db.people.forEach((person) => {
                    data[person.uuid] = [{ allowanceUsed: Math.floor(rng() * 20001) }];
                });
                return new Response(200, {}, data);
            }
            case path.includes('/news/read'):
                return new Response(200, {}, []);
            case path.includes('/core/urgent-message'):
                return new Response(200, {}, '');
        }
    });

    server.get('/clarityanon', (schema, request) => {
        const path = request.queryParams.path;

        switch (true) {
            // News
            case path.includes('/news'):
                console.log('return news!');
                return new Response(200, {}, schema.db.news);
        }
    });

    server.post(proxyName, (schema, request) => {
        const path = request.queryParams.path;
        const data = JSON.parse(request.requestBody);

        switch (true) {
            case path.includes('/valuation/portfolios/benchmark'):
                return new Response(200, {}, { success: true, benchmarkID: Math.floor(rng() * 1000) });
            case path.includes('/valuation/portfolios'):
                if (data.name && data.plans) {
                    return new Response(200, {}, { portfolioID: Math.floor(1000000000 + rng() * 9000000).toString() });
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message: 'Please ensure that the following data has been submitted: Name, Plans',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/valuation/v2/datafeeds'):
                if (data.feed_id && data.provider_reference) {
                    return new Response(200, {}, { success: true });
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message:
                                'Please ensure that the following data has been submitted: feed_id, provider_reference',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/document_export'):
                if (data.payload) {
                    if (data.request_type === 'PDF') {
                        return new Response(200, {}, schema.db.pdfPayload[0]);
                    } else if (data.request_type === 'Excel') {
                        return new Response(200, {}, schema.db.excelPayload[0]);
                    } else {
                        return new Response(
                            400,
                            {},
                            {
                                message: 'Did not recognise request_type',
                                success: false,
                                error: true,
                            }
                        );
                    }
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message: 'Please ensure that the following data has been submitted: payload',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/permissions/client/investmentpermissionsgranted'):
                // mirage is not happy with crypto so change success for string id instead
                // return new Response(200, {}, {success: crypto.randomUUID()});
                return new Response(200, {}, { success: Math.floor(1000 + rng() * 900) });
            case path.includes('/selfmanaged/assets'):
                return new Response(200, {}, { success: true, assetId: '13355fd5-f8e6-499d-83e1-0229110ce173' });
            // Aegon SSO Mock
            case path.includes('/idp/aegon/sso'): {
                const responseCode =
                    '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN"' +
                    '        "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                    '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">' +
                    '<head>' +
                    '    <meta http-equiv="content-type" content="text/html; charset=utf-8" />' +
                    '    <title>POST data</title>' +
                    '    <link type="text/css" rel="stylesheet" href="/idp/aegon/resources/post.css" />' +
                    '</head>' +
                    '<body>' +
                    '' +
                    '    <noscript>' +
                    '        <p><strong>Note:</strong> ' +
                    '        Since your browser does not support JavaScript, ' +
                    '        you must press the button below once to proceed.</p> ' +
                    '    </noscript> ' +
                    '' +
                    '    <form method="post" ' +
                    '        action="https://claritybuy.aegon.co.uk/rest/external/authentication/sso">' +
                    '    <!-- Need to add this element and call click method, because calling ' +
                    '    submit() on the form causes failed submission if the form has another ' +
                    '    element with name or id of submit.' +
                    '    See: https://developer.mozilla.org/en/DOM/form.submit#Specification -->' +
                    '    <input type="submit" id="postLoginSubmitButton"/>' +
                    '<input type="hidden" name="SAMLResponse" value="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" /><input type="hidden" name="RelayState" value="exturl=claritycpmicrosite&relaytoken=123456&context=Top" />        <noscript>' +
                    '            <button type="submit" class="btn">Submit</button>' +
                    '        </noscript>' +
                    '    </form>' +
                    '' +
                    '</body>' +
                    '</html>';

                return new Response(200, {}, responseCode);
            }
            case path.includes('/newsletter'):
                return new Response(200, {}, { status: true });
            case path.includes('/news/read'):
                return new Response(200, {}, { success: true });
        }
    });

    server.patch(proxyName, (schema, request) => {
        const path = request.queryParams.path;
        const data = JSON.parse(request.requestBody);

        switch (true) {
            case path.includes('/valuation/portfolios/benchmark'):
                return new Response(200, {}, { success: true });
            case path.includes('/valuation/portfolios'):
                if (data.name && data.plans) {
                    return new Response(200, {}, { success: true });
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message: 'Please ensure that the following data has been submitted: Name, Plans',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/valuation/v2/datafeeds'):
                if (data.provider_reference) {
                    return new Response(200, {}, { success: true });
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message: 'Please ensure that the following data has been submitted: provider_reference',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/clientpersonaldetails/summary'):
                return new Response(200, {}, { data: preferences['personalDetails'] });
            case path.includes('/websitesettings'):
                return new Response(200, {}, { data: preferences['preferences'] });
            case path.includes('/ims/approvalrecords'):
                if (data['approve']) {
                    return new Response(200, {}, { success: true });
                } else {
                    return new Response(
                        400,
                        {},
                        {
                            message: 'Please ensure that the following data has been submitted: approve',
                            success: false,
                            error: true,
                        }
                    );
                }
            case path.includes('/selfmanaged/assets'):
                return new Response(204);
        }
    });

    server.delete(proxyName, (schema, request) => {
        const path = request.queryParams.path;

        switch (true) {
            case path.includes('/valuation/portfolios'):
                return new Response(204);
            case path.includes('/valuation/v2/datafeeds'):
                return new Response(204);
            case path.includes('/permissions/client/investmentpermissionsgranted'):
                return new Response(204);
            case path.includes('/selfmanaged/assets'):
                return new Response(204);
        }
    });
};

const useValuationPortfolioRoute = (schema) => {
    return new Response(200, {}, schema.db.portfolios[0]);
};

const useValuationSummaryChart = (path, schema) => {
    // const paramsArray = path.split('/')
    // const portfolio = paramsArray[4]
    // const people = paramsArray[5]
    // console.log('portfolio', portfolio, 'people', people)
    let n = rng();
    const data = n < 0.5 ? schema.db.chartData[0] : schema.db.chartData[1];

    return new Response(200, {}, { chartData: data });
};

const useHoldings = (schema) => {
    let n = rng();
    const data = n < 0.5 ? schema.db.holdings[0] : schema.db.holdings[1];
    return new Response(200, {}, data);
};

const useValuationPolicySummaryChart = (path, schema) => {
    let n = rng();
    const baseData = n < 0.5 ? schema.db.chartData[0] : schema.db.chartData[1];

    // then randomise the values in the data
    const randomise = (value) => rng() * (value - 10000) + 10000;

    const data = baseData.map((o) => Object.assign(o, { value: randomise(o.value) }));

    return new Response(200, {}, { chartData: data });
};

const useValuationSummaryChartTotals = (path, schema) => {
    // const paramsArray = path.split('/')
    // const portfolio = paramsArray[4]
    // const people = paramsArray[5]
    // console.log('portfolio', portfolio, 'people', people)
    let n = rng();
    const data = n < 0.5 ? schema.db.chartTotals[0] : schema.db.chartTotals[1];

    return new Response(200, {}, { chartTotalsData: data });
};

const useClientDirectoryService = (path) => {
    switch (true) {
        case path.includes('marketinginfo'):
            return new Response(200, {}, preferences['marketing']);
        case path.includes('clientpersonaldetails'):
            return new Response(200, {}, preferences['personalDetails']);
        case path.includes('websitesettings'):
            return new Response(200, {}, preferences['preferences']);
        case path.includes('countryoptions'):
            return new Response(200, {}, countryOptions);
        case path.includes('groupoptions'):
            return new Response(200, {}, groupOptions);
        default:
            return new Response(400, {}, { error: true, message: 'unknown endpoint or resource.' });
    }
};

const useWealthplanRoutes = (path, schema) => {
    /*
    const params = request.queryParams
    let page = params && params.page ? parseInt(params.page) -1 : 0
    let per_page = params && params.per_page ? parseInt(params.per_page) : 20
    let limit = per_page ?? 20
    let start = page * per_page
    let end = start + limit
     */

    if (path.includes('notes')) {
        // const id = request.queryParams.wealthplanid
        // let notes = schema.messages.findBy({wealthplanid: id})

        return new Response(200, {}, { notes: schema.db.wealthplanNotes[0].list });
    } else {
        return new Response(200, {}, schema.db.wealthplans[0]);
    }
};

const useSelfManagedHoldings = (path) => {
    switch (true) {
        case path.includes('/assets'):
            return new Response(200, {}, selfManagedAssets);
        case path.includes('/producttypes'):
            return new Response(200, {}, selfManagedProductTypes);
        case path.includes('/clarityfundlinks'):
            return new Response(200, {}, fundlinks);
    }
};
